import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { cn } from './lib/cn'

export interface MarkdownProps {
  children: string
  className?: string
}

/** Renders assistant text. react-markdown sanitizes by default (no raw HTML). */
export function Markdown({ children, className }: MarkdownProps) {
  return (
    <div className={cn('prose prose-sm prose-neutral max-w-none break-words', className)}>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{children}</ReactMarkdown>
    </div>
  )
}
